export default __webpack_public_path__ + "static/media/rightArrow.d09f7117.svg";